import { ReactNode, useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from '@medusajs/ui';

import { createQueryClient } from '@lib/query/client';
import { TenantProvider } from '@lib/context/tenant-context';
import { FullScreenLoader } from '@modules/common/components/full-screen-loader';

interface AppProvidersProps {
  children: ReactNode;
}

export function AppProviders({ children }: AppProvidersProps) {
  // Create query client once per app instance
  const [queryClient] = useState(() => createQueryClient());

  return (
    <QueryClientProvider client={queryClient}>
      <HelmetProvider>
        <BrowserRouter>
          <TenantProvider fallback={<FullScreenLoader />}>
            {children}
            <Toaster position="top-center" />
          </TenantProvider>
        </BrowserRouter>
      </HelmetProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}
